
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14cnr_72o6g_141",
  "trigger": "awsui_trigger_14cnr_72o6g_178",
  "dropdown": "awsui_dropdown_14cnr_72o6g_181",
  "nowrap": "awsui_nowrap_14cnr_72o6g_192",
  "open": "awsui_open_14cnr_72o6g_195"
};
  